import React from "react";
import { Button } from "shared/components/atoms/Button";
import { BaseHalfModal } from "shared/components/organisms/modal/BaseHalfModal";
import { FortuneTeller } from "shared/types";
import tw from "twin.macro";

const buttonCss = tw`w-full flex-col rounded`;

const secondaryTextCss = tw`font-normal text-2xs tracking-[.29px] mt-2`;

interface Props {
  onSubmit: (fromNow: boolean) => void;
  fortuneTeller: FortuneTeller;
}

export const SelectReservationOrNowModal = ({
  onSubmit,
  fortuneTeller,
}: Props) => {
  return (
    <BaseHalfModal title="いつ電話鑑定をご希望ですか？">
      <Button
        tw="bg-gradient-theme-to-l"
        css={buttonCss}
        onClick={() => onSubmit(true)}
        disabled={!fortuneTeller.telWaitingFlag}
      >
        今すぐ鑑定を始める
        <span css={secondaryTextCss}>申し込み後すぐに電話鑑定が始まります</span>
      </Button>
      <Button
        tw="mt-4"
        css={buttonCss}
        variant="outline"
        onClick={() => onSubmit(false)}
      >
        鑑定日時を予約する
        <span css={secondaryTextCss}>チャットルームにて鑑定日時を予約する</span>
      </Button>
    </BaseHalfModal>
  );
};
